import { render, staticRenderFns } from "./previewImageForApi.vue?vue&type=template&id=5b2fff7f"
import script from "./previewImageForApi.vue?vue&type=script&setup=true&lang=js"
export * from "./previewImageForApi.vue?vue&type=script&setup=true&lang=js"
import style0 from "./previewImageForApi.vue?vue&type=style&index=0&id=5b2fff7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_css-loader@6.11.0_webpack@5.109.2_cssnano@5.1.15__txhfkviks3ummxta33hlcz7ciy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports